import { useEffect, useState } from "react";
import { UseFormGetValues, UseFormSetValue, FieldPath } from "react-hook-form";
import { BaseButton } from "components/buttons/BaseButton";
import { useKeyPress } from "hooks/useKeyPress";
import { ISignUpFieldValues } from "../AuthSignUp";
import classes from "./SignUpPreferencesStep.module.scss";
import { CheckButton } from "components/buttons/CheckButton";
import authPopupClasses from "./../AuthPopup.module.scss";

interface IProps {
  next: () => void;
  setValue: UseFormSetValue<ISignUpFieldValues>;
  getValues: UseFormGetValues<ISignUpFieldValues>;
}

const PREFERENCES = [
  "Straight", "Gay", "Lesbian", "Trans", "Animated", "Bisexual"
];

const DEFAULTS = PREFERENCES.map(v => v.toLowerCase());

const SignUpPreferencesStep = (props: IProps) => {
  const { next, setValue, getValues } = props;
  const _prefs = getValues().preferences;
  const [preferences, setPreferences] = useState<string[]>(_prefs ? _prefs : DEFAULTS);

  const enterPressed = useKeyPress("Enter");

  const handleNext = () => {
    if (preferences.length > 0) {
      next();
    }
  };

  const handleClick = (value: string) => {
    const newValue = value.toLowerCase();
    const newPreferences = [...preferences];
    let isExist = false;

    newPreferences.forEach((el, index) => {
      if (newValue === el) {
        isExist = true;
        newPreferences.splice(index, 1);
      }
    });

    if (!isExist) {
      newPreferences.push(newValue);
    }

    setPreferences(newPreferences);
  };

  const isSelected = (value: string) => {
    const newValue = value.toLowerCase();
    return preferences.indexOf(newValue) >= 0;
  };

  useEffect(() => {
    setValue<FieldPath<ISignUpFieldValues>>("preferences", preferences);
    // eslint-disable-next-line
  }, [preferences])

  useEffect(() => {
    if (enterPressed) {
      handleNext();
    }
    // eslint-disable-next-line
  }, [enterPressed])

  return (
    <div className={authPopupClasses.ContentContainer}>
      <div className={classes.Title}>Select one or more preferences:</div>

      <div className={classes.Options}>
        {PREFERENCES.map(el => (
          <div className={classes.Option} key={el}>
            <p>{el}</p>
            <CheckButton onClick={() => handleClick(el)} checked={isSelected(el)}/>
          </div>
        ))}
      </div>

      <div className={authPopupClasses.Footer}>
        <BaseButton type="button" onClick={handleNext} disabled={preferences.length < 1}>Next</BaseButton>
      </div>
    </div>
  );
};

export default SignUpPreferencesStep;
